require('./bootstrap');

import { createApp, h } from 'vue';
import { createInertiaApp } from '@inertiajs/inertia-vue3';
import VueRouter from "vue-router";
import {Workbox} from 'workbox-window';
const appName = window.document.getElementsByTagName('title')[0]?.innerText || 'Laravel';

window.axios = require('axios');
window.axios.defaults.baseURL = process.env.MIX_APP_URL;

createInertiaApp({
    title: (title) => `${title}`,
    resolve: (name) => require(`./Home/${name}.vue`),
    setup({ el, app, props, plugin }) {
        return createApp({ render: () => h(app, props) })
            .use(plugin,VueRouter)
            .mixin({ methods: { route } })
            .mount(el);
    },
});


if ('serviceWorker' in navigator) {
    const wb = new Workbox('/service-worker.js');

    wb.register();
}
